export default function List(theme) {
  return {
    MuiList: {
      styleOverrides: {
        root: {
          padding: theme.spacing(1, 0),
          // Navigation lists don't need justifyContent: center when collapsed
          // because the ListItems themselves handle centering
          '&[data-navigation-list="true"]': {
            display: 'flex',
            flexDirection: 'column',
            padding: '10px !important',
            '&[data-collapsed="true"]': {
              justifyContent: 'center', // Center items horizontally when collapsed
              padding: `${theme.spacing(0, 0)} !important`,
            },
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          padding: theme.spacing(1, 1.5),
          margin: theme.spacing(0, 0),
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.selected,
            },
          },
          // Exclude navigation items when minimized - handled by Navigation override
          '&[data-navigation="true"][data-collapsed="true"]': {
            padding: `${theme.spacing(0.5, 2)} !important`,
            margin: `${theme.spacing(1, 0)} !important`,
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: 400,
        },
        secondary: {
          color: theme.palette.text.secondary,
          fontSize: '0.875rem',
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 40,
          color: 'inherit',
          padding: theme.spacing(0, 1.5, 0, 0),
          // Exclude navigation icons - handled by Navigation override
          '&[data-navigation="true"]': {
            minWidth: '0 !important', // Completely remove minWidth for navigation icons
            marginRight: 'auto !important',
            marginLeft: 'auto !important',
          },
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          padding: theme.spacing(1, 2),
          margin: theme.spacing(0.25, 1),
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.selected,
            },
          },
        },
      },
    },
    MuiListItemAvatar: {
      styleOverrides: {
        root: {
          minWidth: 40,
        },
      },
    },
    MuiListItemSecondaryAction: {
      styleOverrides: {
        root: {
          right: theme.spacing(2),
        },
      },
    },
  };
}

